import * as React from "react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import CustomList from "../../modules/CustomList/CustomList";
import DoNotMountComponent from "../../modules/DoNotMountComponent/DoNotMountComponent";
import { TypeForm } from "../../modules/Forms/domain/Forms";
import { Info } from "../../modules/Forms/Views/Info/Info";
import withForm from "../../modules/Forms/withForm";
import Markdown from "../../modules/Markdown/Markdown";
import { has_address, has_country, has_time } from "../../modules/shared/utils/checkInputs";
import { createTitle } from "../../modules/shared/utils/createTitle";

type PropsHeroContact = PropsWithChildren<{
  data: Partial<Queries.SanityHeroContact>;
  settings?: unknown;
}>;

const HeroContact: React.FC<PropsHeroContact> = (props: PropsHeroContact) => {
  if (!props.data || !props.data.resume?.title || !props.data.resume.text || !Array.isArray(props.data.listContact))
    return <DoNotMountComponent sms={"HeroContact"} log={props} />;
  const InfoFormUse = withForm(Info, TypeForm.INFO, "SectionContact");
  const { t } = useTranslation("global");
  const title = createTitle(props.data.resume?.title, "h2");
  return (
    <section className={`o-hero-contact`}>
      <div className={`c-hero-contact`}>
        <div className="hero-contact__info">
          <div className="hero-contact__headline">
            {title}
            <Markdown markdown={props.data.resume.text} />
          </div>
          <CustomList
            data={[
              ...props.data.listContact.map((item) => {
                if (has_time(item)) {
                  return {
                    name: item,
                  };
                } else {
                  if (has_country(item)) {
                    return {
                      name: item,
                    };
                  }
                  return {
                    name: item,
                    link: {
                      slug: item,
                      name: item,
                    },
                  };
                }
              }),
            ]}
          />
        </div>
        <div className="hero-contact__form">
          <InfoFormUse />
        </div>
      </div>
    </section>
  );
};

export { HeroContact };
